export enum SUMMARY_XP_FORMAT {
  C = 'CSV',
  X = 'EXCEL',
  P = 'PDF',
  /** @deprecated - 2025/01/24 */
  T = 'PROJECT',
  E = 'xls',
  D = 'doc',
}

export enum EXPORT_REPORT_SCALE {
  D = 'drawing',
  P = 'project',
}

export enum EXPORT_REPORT_LAYOUT {
  S = 'single-column',
  M = 'multi-column',
  I = 'single-item',
}

export enum ExportScope {
  PG = 'page',
  PJ = 'project',
  NO = 'none',
}

/**
 * @deprecated in favor of `PANEL`
 */
export enum FEATUREPANEL {
  S = 'SINGLE_FEATURE',
  M = 'BATCH_FEATURE',
}

export enum PANEL {
  S = 'SINGLE_REVIEW',
  B = 'BATCH_REVIEW',
  T = 'TOTAL_REVIEW',
  Z = 'ZONE_REVIEW',
}

export enum DimensionSuffix {
  /** other dimension such as width, height, diameter */
  MM = 'mm',
  /** other dimension such as width, height, diameter */
  I = 'in',
  /** for length string in metric */
  M = 'm',
  /** for length string in imperial */
  FT = 'ft',
}

export enum PAGE_UNIT {
  M = 'metric',
  I = 'imperial',
}
/**
 * move to here and use new type: P in PAGE_UNIT
 * @date 2024/10/29
 */
export const unitSuffixs: { [P in PAGE_UNIT]: string } = {
  [PAGE_UNIT.M]: 'M',
  [PAGE_UNIT.I]: 'Ft',
};

/**
 * DO NOT ITERATE THIS COLLECTION, ONLY USE IT INDIVIAULLY
 * @2026/05/26
 */
export enum SPECIAL_JOB_ITEM {
  /** reference boundary line */
  REF = 'DEFAULT',
  RECT_DUCT = 'RECTANGULAR_DUCT',
  /** sub-type of FITTING */
  OFFSET = 'OFFSET_ELBOW',
  EQMT = 'EQUIPMENT',
  FLOW = 'DIRECTION_OF_FLOW',
  LABEL = 'LABEL',
  TJCT = 'T_JUNCTION',
  EBPI = 'ELBOW_PIPING',
  /** rectangular transitions need w1/h1/d1 at the same time - @2025/07/03 */
  RRT = 'RRT_',
  /** text box item - @2025/10/08 */
  TBX = 'TEXTBOX',
  /** END_CAP VIRTUAL symbol - @2025/11/06 */
  EC = 'END_CAP',
  /** for manually added FLEX broken line - @2025/11/27 */
  FLEX = 'FLEX',
  /** Polygon Area */
  POLYGON = 'INSULATION_ZONE',
  /** VIRTUAL insulation symbol - @2026/02/25 */
  INSLT = 'INSULATION_VIRT',
  /** INSULATION RELATION SYMBOL - @2026/05/13 */
  INREL = 'INS_RELATIONSHIP',
  /** to repalce belowing from side-panel - @2026/05/26 */
  STO = 'SIDE_TAKEOFF',
  /** item to replace with SIDE_TAKEOFF - @2026/05/26 */
  CLR = 'CENTER_LINE_REDUCER',
  /** item to replace with SIDE_TAKEOFF - @2026/05/26 */
  ECR = 'ECCENTRIC_REDUCER',
}

export enum SYMBOL_MODE {
  /** symbols after saved */
  INI = 'INITIAL',
  /** new dot, line */
  NEW = 'NEW',
  /** dimension property updated, or being confirmed */
  MOD = 'MODIFIED',
  /** dot or symbol deleted */
  DEL = 'DELETED',
  /** coordinate changed */
  MOV = 'TRANSLATED',
  /** both coordinates and properties changed */
  MIX = 'MOD_AND_MOV',
  /** freeze it no mode change */
  FRZ = 'FREEZE',
  /** relationship PATCH - @2026/03/08 */
  RPT = 'R_PATCH',
  /** relationsip DELETE - @2026/03/08 */
  RDL = 'R_DELETE',
}

/**
 * connected to `versionPalette` of `styleUtils.ts`
 */
export enum SYMBOL_REVISION {
  /**
   * No info at all attached to the symbol except for type:
   * solid & red fill/stroke
   */
  A = '0',
  /**
   * Missing info symbol
   * translucent fill/solid stroke
   */
  B = '1',
  /**
   * Completed info symbol: all the necessary fields are filled
   * 'touched' : 'yellow', that means have made a correction
   * No dimension values or not all dimension values complete,
   * but `system` property available: translucent fill
   */
  C = '2',
  /**
   * All the properties have values: `confirmed`, 'green'
   */
  D = '3',

  /**
   * Manual symbol: dot | line | note | polygon
   * @date 2024/03/19, 2025/10/08
   */
  M = '4',

  /** === Magic brush used 6 themes === */
  /** red theme */
  R = 'red',
  /** orange theme */
  O = 'orange',
  /** yellow theme */
  Y = 'yellow',
  /** green theme */
  G = 'green',
  /** purple theme */
  P = 'purple',
  /** original blue theme */
  BL = '#4361EE',
  /** aqua theme - no system but has size */
  AQ = 'aqua',
  /** gold theme - has both size and system */
  TQ = 'gold',
  /** tangerine - 2026/09/10 */
  TGR = '#FA8128',
  /** merigold - empty-locked-system - 2026/09/10 */
  MRG = '#FCAE1E',
  /** apricot - 2026/09/10 */
  APC = '#ED820E',
  /** sunflower - 2026/09/10 */
  SF = '#ffc20e',
  /** duck feature - boundary line */
  DK = '-1',
}

/**
 * detection mode
 */
export enum DETECTION_MODE {
  A = 'AI',
  M = 'MANUAL',
  /** invisible symbol such as insulation */
  V = 'VIRTUAL',
}

export enum CATALOGUE_SRC {
  /** for specific company */
  C = 'CUSTOM',
  /** built-in common item for all */
  S = 'STANDARD',
}

/**
 * === First level: ITEM_TYPE ===
 *
 * FITTING | LENGTH | LABEL | UNASSIGNED | OFFSET | ANNOTATION
 */
export enum CATALOGUE_TYPE {
  F = 'FITTING',
  L = 'LENGTH',
  LB = 'LABEL',
  UN = 'UNASSIGNED',
  OF = 'OFFSET',
  AN = 'ANNOTATION',
}

/**
 * === Second level: CATEGORY ===
 *
 * Could be called `DEVICE_TYPE`
 *
 * DUCT | PIPE | EQUIPMENT | OFFSET | PLUMBING | TAG
 */
export enum CATALOGUE_CATEGORY {
  D = 'DUCT',
  P = 'PIPE',
  E = 'EQUIPMENT',
  O = 'OFFSET', // FIXME: treat `OFFSET_ELBOW` as a special fitting!
  PLM = 'PLUMBING', // add new category @2024/11/05
  T = 'TEXT', // add new category for note symbol @2025/08/20
  Z = 'ZONE',
  /** VIRTUAL symbol - INSULATION_VIRT symbol */
  V = 'VIRTUAL',
}

export enum LENGTH_TYPE {
  P = 'PIPE_LENGTH',
  D = 'DUCT_LENGTH',
  /** 2025/11/25 */
  F = 'FLEX',
}

/**
 * Symbol Categories in review panel top filter, a subset of `FILTERS` below.
 * @2023/12/07
 */
export const SymbolCategoryOptions: {
  /** DUCT | PIPE */
  category: string;
  /** FITTING | LENGTH */
  type: string;
  /** group(filter) name */
  label: string;
}[] = [
  {
    category: CATALOGUE_CATEGORY.D,
    type: CATALOGUE_TYPE.F,
    label: 'Duct Fittings',
  },
  {
    category: CATALOGUE_CATEGORY.P,
    type: CATALOGUE_TYPE.F,
    label: 'Pipe Fittings',
  },
  {
    category: CATALOGUE_CATEGORY.D,
    type: CATALOGUE_TYPE.L,
    label: 'Duct Lengths',
  },
  {
    category: CATALOGUE_CATEGORY.P,
    type: CATALOGUE_TYPE.L,
    label: 'Pipe Lengths',
  },
  {
    category: CATALOGUE_CATEGORY.E,
    type: CATALOGUE_TYPE.UN,
    label: 'Equipment',
  },
  {
    category: CATALOGUE_CATEGORY.PLM,
    type: CATALOGUE_TYPE.F,
    label: 'Plumbing',
  },
  // {
  //   category: FITTING_TYPE.O,
  //   type: CATALOGUE_TYPE.OF,
  //   label: 'Offset',
  // },
];

export enum FILTER_LABELS {
  DEFAULT = 'Select Filter',
  ALL = 'All Symbols',
  DUCTS = 'All Duct Fittings',
  PIPES = 'All Pipe Fittings',
  DLENT = 'All Duct Lengths',
  PLENT = 'All Pipe Lengths',
  EQMT = 'Equipment',
  OFST = 'Offset',
  ALENT = 'All Lengths',
  PLMBS = 'Plumbing',
  MXPIPE = 'Pipe Lengths and Pipe Fittings',
  MXDUCT = 'Duct Lengths and Duct Fittings',
  MXPIBO = `Pipe lengths, Elbows, and T's`,
}

/**
 * Symbol Filters Types
 *
 * Straight Duct - DLENT
 * Straight Pipe - PLENT
 * Pipe fittings - PIPES
 * Duct Fittings - DUCTS
 * Straight Pipe + Pipe Fittings - MXPIPE
 * Straight Duct + Duct Fittings - MXDUCT
 */
export enum FILTERS {
  DEFAULT = 'default',
  /** no size detected - @2025/08/22 */
  EMPTY = 'empty',
  ALL = 'all',
  /** duct fittings */
  DUCTS = `${CATALOGUE_CATEGORY.D}|${CATALOGUE_TYPE.F}`,
  /** pipe fittings */
  PIPES = `${CATALOGUE_CATEGORY.P}|${CATALOGUE_TYPE.F}`,
  /** straight duct, aka DUCT Length */
  DLENT = `${CATALOGUE_CATEGORY.D}|${CATALOGUE_TYPE.L}`,
  /** straight pipe, aka PIPE Length */
  PLENT = `${CATALOGUE_CATEGORY.P}|${CATALOGUE_TYPE.L}`,
  /** all equipment */
  EQMT = `${CATALOGUE_CATEGORY.E}|${CATALOGUE_TYPE.UN}`,
  /** all offset */
  OFST = CATALOGUE_CATEGORY.O,
  /** all the length */
  ALENT = 'straight_line',
  /** all plumbings */
  PLMBS = `${CATALOGUE_CATEGORY.PLM}|${CATALOGUE_TYPE.F}`,
  /** Straight Pipe + Pipe Fittings */
  MXPIPE = 'PIPE_FITTING_LENGTH',
  /** Straight Duct + Duct Fittings */
  MXDUCT = 'DUCT_FITTING_LENGTH',
  /**
   * Pipe Length + Pipe Elbows + T_JUNCTIONs
   * @2024/12/19 @2025/02/19
   */
  MXPIBO = 'PIPT_LENGTH_ELBOW',
}
/**
 * clien side symbol type definition
 */
export enum SymbolType {
  RECT = 'rect',
  EQUIPMENT = 'point',
  DOT = 'circle',
  LABEL = 'label',
  /** @deprecated */
  POLYGON = 'polygon',
  /**
   * @deprecated
   * added at 2023/06/20
   */
  OFFSET = 'offset',
  /**
   * for pipe line(length) - one segment only: [pt1, pt2]
   */
  SEGMENT = 'singleline',
  /**
   * duct length flex shape - multiple segment: [pt1, pt2, pt3, ...]
   */
  ZIGZAG = 'brokenline',
  /**
   * For `T-junction` symbol, added at 2024/03/13
   */
  TRIANGLE = 'triangle',
  /**
   * For `Offset` symbol, added at 2024/03/13
   */
  DIAMOND = 'diamond',
  /**
   * note symbol, added at 2025/08/20
   */
  NOTE = 'note',
  /**
   * polygon symbol for insulation areas, added at 2026/01/27
   */
  POLYGON_AREA = 'polygon_area',
  /**
   * virtual symbol, does not show up in map
   * but may show properties in side panel
   * such as 'INSULATION_VIRT'
   * @2026/02/26
   */
  VIRT = 'virtual',
  /** properties deletion */
  REL = 'relationship',
}

export enum FEATURESTATE {
  /** this is first state placed on map */
  N = 'normal',
  /** selected state by click */
  A = 'active',
  /** highlighted by mouse over */
  H = 'hovered',
  /** white stroke and fill */
  D = 'disabled',
  /** highlighted by same system */
  L = 'highlighted',
  /** hide size text above the feature */
  T = 'textHidden',
  /** frozen from all user interactions but still visible */
  K = 'locked',
}

export enum FEATUREMODES {
  A = 'auto',
  M = 'modify',
  T = 'translate',
}

export enum DUCTSHAPES {
  /** no shape value */
  EMPTY = '',
  /** Round shape */
  ROUND = 'ROUND',
  /** Rectangular shape */
  SQUARE = 'RECT',
  /** Semi Round-Rectangular shape - @2025/06/25 */
  RNDREC = 'ROUNDRECT',
  /** FLEX shape for FLEX item - @2025/11/25 */
  FLEX = 'FLEX',
}

export const ImperialScaleOptions: { value: string; label: string }[] = [
  { value: '4', label: '3"=1\'-0"' },
  { value: '8', label: '1\u00BD"=1\'-0"' },
  { value: '12', label: '1"=1\'-0"' },
  { value: '16', label: '3/4"=1\'-0"' },
  { value: '24', label: '1/2"=1\'-0"' },
  { value: '32', label: '3/8"=1\'-0"' },
  { value: '48', label: '1/4"=1\'-0"' },
  { value: '64', label: '3/16"=1\'-0"' },
  { value: '96', label: '1/8"=1\'-0"' },
  { value: '360', label: "1/30=1\'=360" },
  { value: '384', label: "1/32=1\'=384" },
  { value: '120', label: '1"=10\'-0"' },
  { value: '128', label: '3/32"=1\'-0"' },
  { value: '192', label: '1/16"=1\'-0"' },
  { value: '240', label: '1"=20\'-0"' },
  { value: '360', label: '1"=30\'-0"' },
  { value: '480', label: '1"=40\'-0"' },
  { value: '600', label: '1"=50\'-0"' },
  { value: '720', label: '1"=60\'-0"' },
  { value: '1200', label: '1"=100\'-0"' },
];

export const DUCTSHAPEOPTS = [
  {
    label: 'Round',
    value: DUCTSHAPES.ROUND,
  },
  {
    label: 'Rectangular',
    value: DUCTSHAPES.SQUARE,
  },
];

/**
 * Drawing types decides the AI modules to use
 */
export const PageTypes = [
  'HVAC',
  'Piping',
  'Equipment',
  'HVAC $ Piping',
  'HVAC & Piping & Equipment',
];

export enum AIModules {
  E = 'equipment_type',
  H = 'hvac_type',
  P = 'piping_type',
  PFT = 'piping_fitting_type',
  /** @deprecated */
  T = 'table_type', // table extraction @2023/10/11
  /** plumbing module @2024/11/27 */
  PLM = 'plumbing_type',
}

export enum CONSTRUCTSECTOR {
  A = 'A',
  B = 'B',
}

export enum PROJECTSTATE {
  T = 'TENDERING',
  R = 'REVIEW',
  S = 'SUBMITTED',
  F = 'FINISHED',
  I = 'INACTIVE',
}

export enum FILECONTYPE {
  // file content type, used as page type
  PDF = 'pdf', // for file
  DEFAULT = 'Other', // unassigned
  HVAC = 'HVAC', // for page
  PIPE = 'Piping', // for page
  HPMIX = 'HVAC and Piping', // for page
  // OTHER = 'Other', // for page
  ELECTRIC = 'electric', // for future...
}

export enum FILESTATUS {
  LOCKED = 'LOCKED',
  PENDING = 'PENDING', // UPLOADED,
  EXTRACTING_PAGES = 'EXTRACTING_PAGES',
  GENERATING_THUMBNAILS = 'GENERATING_THUMBNAILS',
  COMPLETE = 'COMPLETE', // page splitting from pdf done
  ERROR = 'ERROR',
  /** get generated upload url - @2024/10/04 */
  PRESIGNED = 'PRESIGNED',
}

// INIT -> PENDING -> PROCESSING -> COMPLETE | ERROR
export enum JOBSTATUS {
  INIT = 'ISNULL', // to start a job
  PENDING = 'PENDING',
  /** zoomify workflow changed - 2025/10/31 */
  ZOOMINGFY = 'AWAITING_ZOOMIFY',
  PROCESSING = 'PROCESSING',
  /** this is the only correct value for job completion */
  COMPLETE = 'COMPLETE',
  // COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  /** AI job not picked up @2026/01/26 */
  AWAITING_AI_JOB = 'AWAITING_AI_JOB',
}

/**
 * This decide the ribbon setting bar status
 */
export enum PAGESTATUS {
  INIT = 'UPLOADING', //             1. first stage
  UPLOADED = 'UPLOADED', //          2. page ready to proceed AI job
  ZOOMIFY = 'GENERATING_ZOOMIFY', // 3. ZOOMIFYING ...
  COMPLETE = 'COMPLETED', //         4. zoomyfiy processing completed, tiles & symobols ready to use!
  PROCESSING = 'PROCESSING_AI', //   5. AI RUNNING
  ERROR = 'ERROR', //                6. AI JOB ERROR
  LOCKED = 'LOCKED', //              7. inherited from file,
  INVALID = 'INVALID', // no page selected
  PREALGO = 'PREALGO', // valid to run algo
  REVIEWFITTINGS = 'REVIEWFITTINGS',
  REVIEWSYSTEMS = 'REVIEWSYSTEMS',
  SAVING = 'SAVING', // save changes in review step
  REVIEWED = 'REVIEWD', // editor reviewed after saving
  DONE = 'DONE', // all review works completed! Ready to export to pricing
  INACTIVE = 'INACTIVE',
}

export enum DRAWINGSYMBOL {
  CARBON_DIOXIDE = 'CARBON DIOXIDE',
  CENTER_LINE_REDUCER = 'center line reducer',
  ECCENTRIC_REDUCER = 'eccentric reducer',
  ELBOW = 'elbow',
  FIRE_DAMPER = 'Fire Damper',
  PERIMETER_DIFFUSER = 'perimeter diffuser',
  POLYGON_RECTANGULAR_DUCT = 'Polygon Rectangular Duct',
  RECTANGULAR_DUCT = 'Rectangular Duct',
  RETURN_DUCT = 'Return Duct',
  ROUND_DUCT_DOWN = 'Round duct Down',
  SUPPLY_AIR_DIFFUSER = 'Supply Air Diffuser',
  SUPPLY_OR_OUTSIDE_AIR_DUCT = 'Supply or Outside Air Duct',
  THEROSTAT = 'Therostat',
  Y_JUNCTION = 'Y junction',
}
